import type { RouteObject } from "react-router-dom";
import { OrdersPage } from "./pages/OrdersPage";

export const orderRoutes: RouteObject[] = [
  {
    path: "orders",
    element: <OrdersPage />,
  },
];
